<!--<div *ngIf="zipCodeMatched === 2">-->
  <!--<div class="modal-header col-12" style="justify-content: flex-end; margin-bottom: 0; border: none;">-->
    <!--<img title="Close Modal" (click)="closeModal(false)" width="17" height="17" src="assets/images/cross-dark-grey.svg"-->
         <!--style="cursor: pointer;">-->
  <!--</div>-->
  <!--<div class="modal-body">-->
    <!--<h2 class="modal-title customTitle col-12">Change Delivery Zip Code?</h2>-->
    <!--<h3 class="deleteMsg mt-4"><span>Do you want to change your deliver zip code ? </span></h3>-->
  <!--</div>-->

  <!--<div class="modal-footer col-12" style="padding: 30px 75px; justify-content: center; flex-direction: column;">-->
    <!--<button class="btn-green col-10" (click)="closeModal(true)">Proceed</button>-->
    <!--<button class="saveChangesCancel col-10" (click)="closeModal(false)">Cancel</button>-->
  <!--</div>-->
<!--</div>-->


<div *ngIf="zipCodeMatched === 1">
  <div class="modal-header col-12" style="justify-content: flex-end; margin-bottom: 0; border: none;">
    <img title="Close Modal" (click)="closeModal(false)" width="17" height="17" src="assets/images/cross-dark-grey.svg"
         style="cursor: pointer;">
  </div>

  <form class="col-12" [formGroup]="zipCodeForm">

    <div class="modal-body">
      <h2 class="modal-title customTitle col-12">Enter ZIP Code</h2>
      <h3 class="deleteMsg mt-4"><span>Please enter your ZIP code so we can make sure we can deliver to you!</span></h3>
      <br>
      <input class="form-control zipCodeField" formControlName="zipCodeField" name="zipCodeField" minlength="5" maxlength="5" type="text" id="zipCodeField" #zipCodeField
             required style="width: 100%; height: 50px;" autocomplete="off" autofocus placeholder="ZIP Code" mask='00000'>
    </div>

    <div class="modal-footer col-12" style="padding: 0 100px 50px 100px; justify-content: center; flex-direction: column;">
      <button class="btn-green col-12" (click)="checkZipFunction()" [disabled]="zipCodeForm.invalid"
              [ngClass]="{'btn-green-disabled' : zipCodeForm.invalid}">Check Zip</button>
    </div>

  </form>
</div>


<div *ngIf="zipCodeMatched === 2">
  <div class="modal-header col-12" style="justify-content: flex-end; margin-bottom: 0; border: none;">
    <img title="Close Modal" (click)="closeModal(false)" width="17" height="17" src="assets/images/cross-dark-grey.svg"
         style="cursor: pointer;">
  </div>

  <div class="modal-body">
    <h2 class="modal-title customTitle col-12">ZIP Code within Delivery Zone</h2>
    <h3 class="deleteMsg mt-4"><span>This dish has been added to your cart.</span></h3>
    <br>
  </div>

  <div class="modal-footer col-12" style="padding: 50px 100px; justify-content: center; flex-direction: column;">
    <button class="btn-green col-12" (click)="closeModal(true)">Okay</button>
  </div>
</div>


<div *ngIf="zipCodeMatched === 3">
  <div class="modal-header col-12" style="justify-content: flex-end; margin-bottom: 0; border: none;">
    <img title="Close Modal" (click)="closeModal(false)" width="17" height="17" src="assets/images/cross-dark-grey.svg"
         style="cursor: pointer;">
  </div>

  <form class="col-12" [formGroup]="zipCodeForm">

    <div class="modal-body">
      <h2 class="modal-title customTitle col-12">Sorry! We Don't Deliver There Yet</h2>
      <br><br><br><br><br><br>
    </div>

    <div class="modal-footer col-12" style="padding: 0 100px 50px 100px; justify-content: center; flex-direction: column;">
      <button class="btn-green col-12" (click)="closeModal(false)">Okay</button>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/shared/zip-code/zip-code.component.html